import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* V9-B1 — /simulation?ref=CODE : résout le courtier du lien côté serveur, puis redirige vers /s/{slug}?ref=CODE.
   Sans ref (ou code invalide) : comportement historique → /s/teddy. Aucune donnée partenaire exposée. */
export default function SimulationRedirect() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  const [target, setTarget] = useState(ref ? null : "/s/teddy");
  useEffect(() => {
    if (!ref) return;
    const qs = params.toString();
    axios.get(`${API}/public/simulator/resolve-ref`, { params: { code: ref } })
      .then((r) => setTarget(`/s/${r.data.slug}?${qs}`))
      .catch(() => setTarget("/s/teddy"));
  }, [ref, params]);
  if (!target) return <div className="min-h-screen flex items-center justify-center text-sm text-slate-400" data-testid="sim-redirect-loading">Chargement…</div>;
  return <Navigate to={target} replace />;
}
